(function() {

    /* globals translations */

    'use strict';

    var I18n = function I18n(translations, fallback) {

        this.translations = translations;
        this.locale = document.documentElement.lang || fallback;

        this.interpolate = function(translation, values) {

            if(values === undefined) {
                return translation;
            }

            return translation.replace(/%\{([a-z_]+)}/g, function (match, variable) {
                var value = values[variable];
                return typeof value === 'string' || typeof value === 'number' ? value : match;
            });

        };

    };

    I18n.prototype.t = function t(key, values) {

        var translation;

        key = this.locale + '.' + key;

        if(this.translations[key] !== undefined) {

            translation = this.translations[key];
            translation = this.interpolate(translation, values);

        } else {
            translation = 'Translation for ' + key + ' is missing.';
        }

        return translation;

    };

    window.i18n = new I18n(translations, 'en');

})();